import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import type { Farm } from "@/mocks/farms";

export default function FarmsHero({ farms }: { farms: Farm[] }) {
  const villageCount = new Set(farms.map((farm) => farm.village)).size;

  return (
    <section className="relative min-h-[70vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Expansive%20aerial%20view%20of%20the%20Godavari%20delta%20farmland%20with%20patchwork%20green%20paddy%20fields%2C%20coconut%20groves%20and%20winding%20canals%20meeting%20in%20the%20distance%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20soft%20natural%20light%2C%20sweeping%20rural%20Indian%20panorama%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=farms-hero&orientation=landscape"
          width={1920}
          height={1080}
          alt="Aerial view of Godavari delta farmland with paddy fields and coconut groves"
          title="Discover farms - Rythugaru agri tourism"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-14 md:pb-20">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Discover Farms</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            Farms of the Godavari Delta
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Stand in the Field Where Your Food is <span className="italic text-accent-300">Grown.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          Paddy fields, coconut groves, banana plantations and mango orchards — meet the farms that
          open their gates to visitors, and see exactly where in the delta each one sits.
        </p>

        <div className="flex flex-wrap gap-x-10 gap-y-5 mt-10">
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              {farms.length}
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Farms Listed</p>
          </div>
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              {villageCount}
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Villages Across the Delta</p>
          </div>
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              100%
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Farmer Hosted</p>
          </div>
        </div>
      </div>
    </section>
  );
}